import React, { Component } from 'react'
import styled from "styled-components"
import { Table, Popconfirm, Divider, Button, Spin, Modal, message } from 'antd'
import MenuForm from '@/components/Menu/MenuForm'
import MenuAPI from '@/API/menu'
import { withTranslation } from 'react-i18next';

const ButtonContainer=styled.div`
  text-align:right;
`
const AddButton=styled(Button)`
  margin:20px 20px;
`
const OperatorTable=styled(Table)`
  margin:0 20px;
`

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuList:[],
      loading:false,
      modalType:'add',
      modalShow:false,
      confirmLoading:false,
      pagination:{
        current:1,
        pageSize:10,
        total:0,
        showSizeChanger:true,
        size:'small',
        showTotal:(total)=>(this.props.t('Total items',{total:total}))
      },
      menu:{}
    }
    this.columns=[
      {
        title:this.props.t('Menu ID'),
        dataIndex:'id',
        key:'id'
      },
      {
        title:this.props.t('Menu Name'),
        dataIndex:'name',
        key:'name'
      },
      {
        title:this.props.t('Menu URL'),
        dataIndex:'url',
        key:'url'
      },
      {
        title:this.props.t('Operation'),
        key:'action',
        width:150,
        align:'center',
        render:(text,record)=>(
          <span>
            <a onClick={()=>this.initEdit(record)}>{this.props.t('Edit')}</a>
            <Divider type="vertical" />
            <Popconfirm title={this.props.t('Delete the menu?')} okType="danger" onConfirm={()=>this.deleteMenu(record)}>
              <a>{this.props.t('Delete')}</a>
            </Popconfirm>
          </span>
        )
      }
    ]
  }
  componentDidMount() {
    this.getMenuList()
  }
  
  fieldChange=(key,value)=>{
    let field={}
    field[key]=value
    this.setState(prevState=>({
      ...prevState,
      menu:{
        ...prevState.menu,
        ...field
      }
    }))
  }
  initAdd=()=>{
    this.setState({
      modalType:'add',
      modalShow:true,
      menu:{
        name:'',
        url:''
      }
    })
  }
  initEdit=(menu)=>{
    this.setState({
      modalType:'edit',
      modalShow:true,
      menu:menu
    })
  }
  getMenuList=()=>{
    this.setState({loading:true})
    const {pagination}=this.state
    MenuAPI.getMenuList({pageIndex:pagination.current-1,pageSize:pagination.pageSize}).then((res)=>{
      this.setState((state)=>{
        return {menuList:res.menus,pagination:{...state.pagination,total:res.totalCount}}
      })
      this.setState({loading:false})
    })
  }
  hideModal=()=>{
    this.setState({modalShow:false})
  }
  addMenu(menu){
    this.setState({confirmLoading:true})
    MenuAPI.addMenu(menu).then((res)=>{
      if(!res.code){
        this.hideModal()
        message.success(this.props.t('Added successfully.'))
        this.getMenuList()
      }
      this.setState({confirmLoading:false})
    }).catch(()=>{
      this.setState({confirmLoading:false})
    })
  }
  editMenu(menu){
    this.setState({confirmLoading:true})
    MenuAPI.editMenu(menu).then((res)=>{
      if(!res.code){
        this.hideModal()
        message.success(this.props.t('Edited successfully.'))
        this.getMenuList()
      }
      this.setState({confirmLoading:false})
    }).catch(()=>{
      this.setState({confirmLoading:false})
    })
  }
  deleteMenu=(menu)=>{
    MenuAPI.deleteMenu({id:menu.id}).then((res)=>{
      if(!res.code){
        message.success(this.props.t('Deleted successfully.'))
        this.getMenuList()
      }
    })
  }
  handleOk=()=>{
    if(this.state.menu.name&&this.state.menu.url){
      if(this.state.modalType==='add'){
        this.addMenu(this.state.menu)
      }else{
        this.editMenu(this.state.menu)
      }
    }
  }
  handleCancel=()=>{
    this.setState({modalShow:false})
  }
  handleTableChange=(pagination)=>{
    this.setState({
      pagination: pagination,
    },()=>{
      this.getMenuList()
    });
  }
  render() {
    const {pagination,menuList,loading,modalShow,modalType,confirmLoading,menu}=this.state
    const { t } = this.props;
    return (
      <div>
        <ButtonContainer>
          <AddButton type="primary" onClick={this.initAdd}>{t('Add Menu')}</AddButton>
        </ButtonContainer>
        <Spin spinning={loading}>
          <OperatorTable dataSource={menuList} columns={this.columns} pagination={pagination} rowKey="id" onChange={this.handleTableChange}></OperatorTable>:<div></div>
        </Spin>
        <Modal maskClosable={false} title={modalType==='add'?t('Add Menu'):t('Edit Menu')} visible={modalShow} onOk={this.handleOk} confirmLoading={confirmLoading} onCancel={this.handleCancel}>
          <MenuForm fieldChange={this.fieldChange} menu={menu}></MenuForm>
        </Modal>
      </div>
    )
  }
}

export default withTranslation()(Menu)